<template>
  <div class="basic-block block-review-base" :style="styles">
    <img v-if="targetInfo.review.deco" :src="targetInfo.review.deco" class="block-review-base__deco" alt="">
    <div class="content-wrap">
      <div class="block-review-base__inner">
        <lp-title title="お客様からの声" :color-scheme="colorScheme" alphabet="reviews" />
        <ul class="block-review-base__list">
          <li v-for="(item, idx) of reviewList" :key="idx">
            <img :src="item.icon" alt="">
            <p>{{ item.review }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import LpTitle from '../partials/LpTitle'

export default {
  name: 'BlockReview',
  components: {
    LpTitle,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    deco: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-review-base {
  padding: 60px 0 60px;
  background: #fff;
  &__deco {
    position: absolute;
    top: -46px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
  }
  &__list {
    margin: 0;
    padding: 4px 20px;
    list-style: none;
    background: #FFFFFF;
    border: 1px solid #DADADA;
    border-radius: 10px;
    > li {
      padding: 16px 0 16px 2px;
      display: flex;
      align-items: center;
      + li {
        border-top: 1px solid #DADADA;
      }
      img {
        max-width: 55px;
        margin: 0 11px 0 0;
      }
      p {
        margin: 0;
        font-size: 12px;
        line-height: 18px;
        text-align: justify;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockReview.vue